// extracted by mini-css-extract-plugin
export default {"feature-tooltip":"x0fp3t","featureTooltip":"x0fp3t","content":"Jv6Z3f","close-button":"x6dIj3","closeButton":"x6dIj3"};